import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=299a6285&"
import script from "./TableCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./TableCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports